import type {QueryClient} from '@tanstack/react-query'

import {savedLocationKeys} from './query-keys'

/**
 * Drop a customer's cached saved locations after a flow that can create them server-side.
 *
 * Job, project, and schedule creation persist saved locations as a side effect of
 * `rememberAsSavedLocation`, so the saved-location mutation hooks — and their invalidation —
 * never run. Queries default to `staleTime: Infinity`, so without this the customer page keeps
 * serving the list it cached before the new location existed.
 */
export function invalidateCustomerSavedLocations(queryClient: QueryClient, customerId: string) {
    void queryClient.invalidateQueries({queryKey: savedLocationKeys.lists(customerId)})
}
